const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/ExternalPage/AppBar/AppBar.tsx';
import { AppBar as CommonAppBar } from 'App/components/AppBar/AppBar';
import textMap from './translations';
import { useIntl } from 'react-intl';

export interface IAppBarProps {
    title: string;
}

export const AppBar = (props: IAppBarProps) => {
    const { formatMessage } = useIntl();
    return <CommonAppBar leftBtnKind="cross" primaryText={props.title || formatMessage(textMap.appBarTitle)} />;
};
